import { ADD_PATIENT_SUCCESS } from '../types/patient.types';
import type { AddPatientOutcome, AddPatientResult } from '../types/patient.types';

const OUTCOME_MAP: Record<string, AddPatientOutcome> = {
  registered: 'registered',
  attached: 'attached',
  invalidcode: 'invalidCode',
  invalidssn: 'invalidSsn',
  notdefined: 'notDefined',
  existingaccount: 'existingAccount',
  alreadyattached: 'alreadyAttached',
  alreadyused: 'alreadyUsed',
  attachedtoomany: 'attachedTooMany',
  duplicatessn: 'duplicateSsn',
};

export function mapOutcome(value?: string | null): AddPatientOutcome {
  return OUTCOME_MAP[(value ?? '').toLowerCase()] ?? 'unknown';
}

/**
 * Normalizes a raw `RegisterPatient` body (v1 envelope or v2) into an
 * `AddPatientResult`. `wasAttach` mirrors the request's `attachPatient` flag —
 * it only picks the fallback outcome label when the server said success but
 * sent an unrecognized outcome string.
 */
export function toAddPatientResult(
  raw: {
    success?: boolean;
    outcome?: string | null;
    username?: string | null;
    attachedAt?: string[] | null;
  },
  wasAttach: boolean,
): AddPatientResult {
  const outcome = mapOutcome(raw.outcome);
  const success = raw.success === true || ADD_PATIENT_SUCCESS.has(outcome);
  return {
    success,
    outcome: success && outcome === 'unknown' ? (wasAttach ? 'attached' : 'registered') : outcome,
    username: raw.username ?? undefined,
    attachedAt: raw.attachedAt?.length ? raw.attachedAt : undefined,
  };
}
